import { Container, WarningMessage, Logo, MainHeaderContainer } from "./style";

import React, { useEffect, useState } from "react";
import  logoImg  from "../../../assets/images/logo.svg";

interface Props {
	queryString: string;
}

const index: React.FC<Props> = ({ queryString }) => {

	const [message, setMessage] = useState("")

	// const fetchData = async () => {
	// 	const headers = {
	// 		"X-Api-Key": "yLnaRQj9hycxEyQEX4cVOPrfxAg5bZAx7jYI+jJc/dE=",
	// 	};

	// 	const options = {
	// 		headers: headers,
	// 	};
	// 	const response = await axiosInstance.get(`${API_ENDPOINTS.LOCALIZATION}?key=${queryString}`, options);
	// 	setMessage(response?.data?.result[0]?.label ?? "")
	// };

	// useEffect(() => {
	// 	fetchData();
	// }, []);

	return (
		<>
			<MainHeaderContainer>
				<Container id="header-container">
					<Logo src={logoImg} alt="kochr" />
				</Container>
			</MainHeaderContainer>
			<WarningMessage>{message}</WarningMessage>
		</>
	);
};

export default index;